
import { useNavigate, useParams, Link } from "react-router-dom";
import { config } from "../../config/config";
import productService from '../../service/ProductService';
import React, { useEffect, useState, useCallback } from "react";
import Pagination from "react-js-pagination";
import userService from "../../service/UserService";
import { Button, Col, Container, Row, Table } from "react-bootstrap";
import debounce from 'lodash/debounce';
import { ToastContainer, toast } from "react-toastify";
import swal from 'sweetalert';

export const ViewProductDetail = () => {
  const navigate = useNavigate();

  const { id } = useParams();
  const [productDetails, setProductDetails] = useState({});
  const [filter, setFilter] = useState({ status: null, search: null })
  const [users, setUsers] = useState([])
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [orderDetails, setOrderDetails] = useState(null);

  const [pagination, setPagination] = useState({ pageNumber: 1, pageSize: 10, pageRange: 0, totalCount: 0 })

  useEffect(() => {
    fetchProductDetails();
  }, [])

  const fetchProductDetails = async () => {
    const response = await productService.getDetail(id);
    if (response.status == 200) {
      const productDetail = response.data.data.product;
      setOrderDetails(response.data.data.order)
      setProductDetails(productDetail)
    }
  }

  useEffect(() => {
    if (orderDetails?.sellerId) {
      fetchUsers();
    }
  }, [orderDetails?.sellerId, pagination.pageNumber, filter.search]);

  const fetchUsers = async () => {
    const longitude = orderDetails?.location?.coordinates?.[0];
    const latitude = orderDetails?.location?.coordinates?.[1];

    const params = { search: filter.search, page: pagination.pageNumber - 1, size: pagination.pageSize,sellerId : orderDetails?.sellerId,productLatitude :latitude,productLongitude:longitude}
    const response = await userService.getAvailableValidator(params);
    if (response.status == 200) {
      setUsers(response.data.data.users)
      setPagination({
        ...pagination,
        totalCount: response.data.data.count
      })
    }
  }

  const debouncedSearch = useCallback(
    debounce((query) => {
      if (query === '') query = null;
      setFilter((prev) => ({ ...prev, search: query }));
    }, 500),
    []
  );

  const applySearch = (e) => {
    const query = e.target.value.trim();
    debouncedSearch(query);
  };

  const handlePageChange = (pageNumber) => {
    setPagination({
      ...pagination,
      pageNumber: pageNumber
    })
  };

  const assignValidatorToProduct = async () => {
    if (!selectedUserId) {
      toast.error("Please select a validator.");
      return;
    }

      const response = await productService.assignValidator(orderDetails._id, selectedUserId);

      if (response.status === 200) {
        fetchUsers();
        fetchProductDetails();
        swal({
          icon: 'success',
          text: response.data.message,
          button: "OK"
        });
      } else {
        swal({
          icon: 'error',
          text: "This product is no longer available for validation.",
          button: "OK"
        }).then(() => window.location.reload());
      }
   } 
  


  const handleValidatorRequest = async (status) => {
    const data = { orderId: orderDetails._id,status : status}
    const response = await productService.updateValidatorRequestStatus(data);
    if (response.status === 200) {
      fetchProductDetails();
      swal({ icon: 'success', text: response.data.message, button: "OK" });
    }
  };

  const cancelOrderValidation = async () => {
    const confirm = await swal({
      title: "Are you sure?",
      text: "Do you really want to remove the validator from this order?",
      icon: "warning",
      buttons: ["Cancel", "Yes, remove"],
      dangerMode: true,
    });

    if (confirm) {
      const response = await productService.cancelOrderValidation(orderDetails._id);
      if (response.status === 200) {
        fetchUsers();
        fetchProductDetails();
        swal({ icon: 'success', text: "Validator removed successfully!", button: "OK" });
      }
    }
  };


  return (
    <>
      <div className="dashboard-main-area">
        <Container fluid>
          <div className="dashboard-area-heading management-heading unset-height">
            <Row className="row justify-content-center align-items-center mb-2">
              <Col md={12}>
                <div className="d-flex justify-content-between mb-2">
                  <div className="d-flex referral-details">
                    <h2 className="user-info-heading"><i className="fa fa-angle-left" aria-hidden="true" onClick={() => navigate('/products')}></i>Product Details</h2>
                  </div>
                </div>
              </Col>
              <Row>
                <Col md={6}>
                  <div className="referral-detail-body">
                    <h6>Product Name</h6>
                    <p>{productDetails?.name}</p>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="referral-detail-body">
                    <h6>Product Description</h6>
                    <p>{productDetails?.description || 'NA'}</p>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="referral-detail-body">
                    <h6>Category </h6>
                    <p>{productDetails?.category?.name}</p>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="referral-detail-body">
                    <h6>Price</h6>
                    <p>{productDetails?.price}</p>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="referral-detail-body">
                    <h6>Product Location</h6>
                    <p>{productDetails?.address}</p>
                  </div>
                </Col>
                <Col md={12}>
                  <div className="unit-switchboard-area">
                    {productDetails?.images?.length > 0 && (
                      productDetails.images.map((media, index) => (
                        <div key={index}>
                          <div className="unit-switchboard-inner">
                            <img src={config.resourceUrl.concat(media)} />
                            <p>User Images</p>
                          </div>
                        </div>
                      ))
                    )}
                  </div>
                </Col>
              </Row>
            </Row>
            
            {orderDetails?.validatorId != null && (
              <>
                <div className="mb-2">
                  <h4 className="fw-bold text-primary">Validation Details</h4>
                </div>
                <Row className="pb-4 border border-2 border-primary rounded p-2">
                  <Col md={6}>
                    <div className="referral-detail-body">
                      <h6>Validator Name</h6>
                      <p>{orderDetails?.validatorId?.fullName}</p>
                    </div>
                  </Col>
                  {orderDetails.status !== "VALIDATED" && orderDetails.status !== "VALIDATION_REQUEST_SENT" && (
                    <Col md={6} className="text-end d-flex justify-content-end align-items-start p-0">
                      <Button className="btn-cancel-detail" onClick={cancelOrderValidation}>Cancel</Button>
                    </Col>
                  )}

                  {orderDetails.status == "VALIDATION_REQUEST_SENT" && (
                    <Col md={6} className="text-end d-flex justify-content-end align-items-start p-0 gap-2">
                      <Button className="btn-accept-detail" onClick={() => handleValidatorRequest("ACCEPT")}>Accept</Button>
                      <Button className="btn-cancel-detail" onClick={() => handleValidatorRequest("REJECT")}>Reject</Button>
                    </Col>
                  )}
                   
                  <Col md={6}>
                    <div className="referral-detail-body">
                      <h6>Validator Phone</h6>
                      <p>{orderDetails?.validatorId?.phone}</p>
                    </div>
                  </Col>

                  <Col md={6}>
                    <div className="referral-detail-body">
                      <h6>Email</h6>
                      <p>{orderDetails?.validatorId?.email || "N/A"}</p>
                    </div>
                  </Col>
                </Row>
              </>
            )}
          </div>
           {/* validator area start */}
      {orderDetails?.status != "VALIDATION_IN_PROGRESS" && orderDetails?.status != "VALIDATED" && orderDetails?.status != "VALIDATION_REQUEST_SENT" && (
       <>
        <div className="  ">
            <div className="dashboard-area-heading management-heading">

              <Row className="row justify-content-center align-items-center mb-2">
                <Col md={12}>
                  <div className="d-flex justify-content-between mb-2">
                    <div className="d-flex ">
                      <h2 className="align-self-center m-0">Available Validator</h2>
                    </div>
                    <div className='d-flex justify-content-center gap-2'>

                      <div className='filter-section d-flex gap-2'>
                        <div className='position-relative'>
                          <i class="fa fa-search position-absolute w-100" aria-hidden="true"></i>
                          <input type='text' className='form-control' placeholder='Search by name or categories...' onInput={applySearch} />
                        </div>
                        <div>
                          <Button onClick={() => assignValidatorToProduct()}>Assign Validator</Button>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>

              <Row className="pb-4 justify-content-center">
                <Col md={12}>
                  <div className="audit-request-box">
                    <Table responsive="sm" className="UserListTable">
                      <thead>
                        <tr>
                          <th></th>
                          <th>Name</th>
                          <th>Phone</th>
                          <th>Address</th>
                          <th>Distance</th>
                          <th>Validation Categories</th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          users.map((user, index) => (
                            <tr key={index}>
                              <td>
                                <input
                                  type="radio"
                                  name="selectedUser"
                                  value={user._id}
                                  checked={selectedUserId === user._id.toString()} // convert _id to string
                                  onChange={() => setSelectedUserId(user._id.toString())} // store as string
                                />
                              </td>
                              <td>{user.fullName}</td>
                              <td>{user.phone}</td>
                              <td>{user?.address}</td>
                              <td>{user.distance ? user.distance + " km": "N/A"}</td>
                              <td>
                                {user?.validator?.productTypes && user.validator.productTypes.length > 0
                                  ? user.validator.productTypes.join(", ")
                                  : "NA"}
                              </td>
                            </tr>
                          ))
                        }

                        {pagination.totalCount == 0 &&

                          <tr className="no-dat-found-box">
                            <td colSpan={10}>
                              <img src={require("../../assets/images/no-data-bg.gif")} alt="no-data-image" />
                              <h3 className="text-center">
                                No Validator found
                              </h3>
                            </td>
                          </tr>
                        }
                      </tbody>
                    </Table>

                    {pagination.totalCount > pagination.pageSize &&
                      <Pagination
                        activePage={pagination.pageNumber}
                        itemsCountPerPage={pagination.pageSize}
                        totalItemsCount={pagination.totalCount}
                        pageRangeDisplayed={pagination.pageRange}
                        onChange={(e) => handlePageChange(e)}
                        prevPageText={"Prev"}
                        nextPageText={"Next"}
                      />
                    }
                  </div>
                </Col>
              </Row>
            </div>
        </div>
         </>
      )}
        </Container>
      </div>

     

    </>
  )
};